
define('css!lib/flatpickr/flatpickr',[],function(){});
